export { default } from "./PostList";
export type { PostListProps } from "./PostList";
